import { getcomparables, searchComparableHistory, exportExcelComparables, parseStockComparables, getCardsData, saveValuation, GetSavedValuation, RemoveValuation, LoadValuation } from '@/api/comparables'
const state = {
  currentComparables: [],
  currentFilter: {},
  selectedcomparables: [],
  filteringByGeolevel: true,
  imageMapExport: null,
  stockTableDataExport: null,
  dataSidebarExport: null,
  fromsearch: false
}

const mutations = {
  SET_CURRENT_COMPARABLES: (state, currentComparables) => {
    state.currentComparables = currentComparables
  },
  SET_CURRENT_FILTER: (state, currentFilter) => {
    state.currentFilter = currentFilter
  },
  SET_FROM_SEARCH: (state, fromsearch) => {
    state.fromsearch = fromsearch
  },
  SET_CURRENT_SELECTED: (state, selectedcomparables) => {
    state.selectedcomparables = selectedcomparables
  },
  SET_FILTERING_GEOLEVEL: (state, filtergeolevel) => {
    state.filteringByGeolevel = filtergeolevel
  },
  SET_IMAGE_MAP_EXPORT: (state, val) => {
    state.imageMapExport = val
  },
  SET_STOCK_TABLE: (state, val) => {
    state.stockTableDataExport = val
  },
  SET_DATA_BAR: (state, val) => {
    state.dataSidebarExport = val
  }
}

const actions = {
  setImageMapExport({ state, commit }, { value }) {
    commit('SET_IMAGE_MAP_EXPORT', value)
  },
  setDataBar({ state, commit }, value) {
    commit('SET_DATA_BAR', value)
  },
  setStockTable({ state, commit }, value) {
    commit('SET_STOCK_TABLE', value)
  },
  setFromSearch({ state, commit }, value) {
    commit('SET_FROM_SEARCH', value)
  },
  getcomparables({ commit, state }, currentFilter) {
    if (currentFilter.c_latitud === null || currentFilter.c_latitud === undefined || currentFilter.c_latitud === '' ||
        currentFilter.c_longitud === null || currentFilter.c_longitud === undefined || currentFilter.c_longitud === '') {
      console.log('valuations no location data')
      return
    }
    return new Promise((resolve, reject) => {
      const searchdata = getsearchdata(currentFilter)
      getcomparables(searchdata).then(response => {
        commit('SET_CURRENT_COMPARABLES', response.data)
        commit('SET_CURRENT_FILTER', currentFilter)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  setcomparables({ commit, state }, data) {
    // debugger
    return new Promise((resolve, reject) => {
      commit('SET_CURRENT_COMPARABLES', data.currentComparables)
      commit('SET_CURRENT_FILTER', data.currentFilter)
      resolve()
    })
  },
  setfilter({ commit, state }, currentFilter) {
    if (currentFilter.c_latitud === null || currentFilter.c_latitud === undefined || currentFilter.c_latitud === '' ||
        currentFilter.c_longitud === null || currentFilter.c_longitud === undefined || currentFilter.c_longitud === '') {
      console.log('valuations no location data')
      return
    }
    return new Promise((resolve, reject) => {
      commit('SET_CURRENT_FILTER', currentFilter)
      resolve()
    })
  },
  setselectedcomparables({ commit, state }, selectedcomparables) {
    return new Promise((resolve, reject) => {
      commit('SET_CURRENT_SELECTED', selectedcomparables)
      resolve()
    })
  },
  setfilteringByGeolevel({ commit, state }, val) {
    return new Promise((resolve, reject) => {
      commit('SET_FILTERING_GEOLEVEL', val)
      resolve()
    })
  },
  searchcomphistory({ commit, state }, query) {
    return new Promise((resolve, reject) => {
      searchComparableHistory(query).then(response => {
        resolve(response.data)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  },
  saveValuation({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      saveValuation(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  },
  downloadcomps({ commit, state }, query) {
    query.query = getsearchdata(query.query)
    return new Promise((resolve, reject) => {
      exportExcelComparables(query).then(response => {
        resolve(response.data)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  },
  parseStockComparables({ commit, state }, query) {
    return new Promise((resolve, reject) => {
      parseStockComparables(query).then(response => {
        resolve(response.data)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  },
  getCardsData({ commit, state }, query) {
    return new Promise((resolve, reject) => {
      getCardsData(query).then(response => {
        resolve(response.data)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  },
  RemoveValuation({ commit, state }, query) {
    return new Promise((resolve, reject) => {
      RemoveValuation(query).then(response => {
        resolve(response.data)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  },
  LoadValuation({ commit, state }, query) {
    return new Promise((resolve, reject) => {
      LoadValuation(query).then(response => {
        resolve(response.data)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  },
  GetSavedValuation({ commit, state }) {
    return new Promise((resolve, reject) => {
      GetSavedValuation().then(response => {
        resolve(response.data)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

function getsearchdata(currentFilter) {
  const categorias = []
  if (currentFilter.more_filters.published) {
    categorias.push('Publicados')
  }
  if (currentFilter.more_filters.unpublished) {
    categorias.push('No publicados')
  }
  if (currentFilter.more_filters.rec_unpublished) {
    categorias.push('Despublicados Recientes')
  }
  const typos = []
  if (currentFilter.flat.flat_type.includes('all')) {
    // no hacemos nada y lo mandamos vacio
  } else {
    if (currentFilter.flat.flat_type.includes('flat')) {
      typos.push(1)
    }
    if (currentFilter.flat.flat_type.includes('house')) {
      typos.push(2)
    }
    if (currentFilter.flat.flat_type.includes('industrial')) {
      typos.push(10)
    }
    if (currentFilter.flat.flat_type.includes('office')) {
      typos.push(7)
    }
    if (currentFilter.flat.flat_type.includes('landplot')) {
      typos.push(5)
    }
    if (currentFilter.flat.flat_type.includes('retail')) {
      typos.push(6)
    }
    if (currentFilter.flat.flat_type.includes('hospitality')) {
      typos.push(9)
    }
    if (currentFilter.flat.flat_type.includes('parking')) {
      typos.push(3)
    }
    if (currentFilter.flat.flat_type.includes('storage')) {
      typos.push(4)
    }
    if (currentFilter.flat.flat_type.includes('other')) {
      typos.push(11)
    }
  }
  var poly = currentFilter.c_polygon && currentFilter.c_polygon.length > 0 ? currentFilter.c_polygon[0] : currentFilter.c_polygon

  const searchdata = {
    tipos: typos,
    c_ascensor: currentFilter.other_features.c_elevator,
    c_carteraclte: currentFilter.more_filters.re_websites,
    categorias: categorias,
    habitaciones: currentFilter.rooms.rooms_num,
    c_latitud: currentFilter.c_latitud,
    c_longitud: currentFilter.c_longitud,
    c_pais: currentFilter.c_pais,
    c_parking: currentFilter.other_features.c_parking,
    c_polygon: poly,
    c_direxacta: currentFilter.more_filters.exact_location,
    tipo_producto: currentFilter.sale.c_tipo_producto,
    tipocontrato: [currentFilter.sale.c_tipo_contrato],
    c_trastero: currentFilter.other_features.c_storage,
    max_c_anyo: currentFilter.more_filters.construct_year.max,
    max_c_eurom2: currentFilter.prices.price_sqm.max,
    max_c_fechabaja: currentFilter.more_filters.exit_date.max,
    max_c_fechaintro: currentFilter.more_filters.in_date.max,
    max_c_precio: currentFilter.prices.price.max,
    max_c_precioalq: currentFilter.prices.rent_mo.max,
    max_c_superficie: currentFilter.sqm_filter.sqm.max,
    max_radius: currentFilter.more_filters.search_radius,
    min_c_anyo: currentFilter.more_filters.construct_year.min,
    min_c_eurom2: currentFilter.prices.price_sqm.min,
    min_c_fechabaja: currentFilter.more_filters.exit_date.min,
    min_c_fechaintro: currentFilter.more_filters.in_date.min,
    min_c_precio: currentFilter.prices.price.min,
    min_c_precioalq: currentFilter.prices.rent_mo.min,
    min_c_superficie: currentFilter.sqm_filter.sqm.min
  }
  return searchdata
}
